import type { NavItem, WebModule } from '@itc/sdk';
import fleet from '@itc-mod/fleet/web';
import timers from '@itc-mod/timers/web';
import bank from '@itc-mod/bank/web';
import supply from '@itc-mod/supply/web';
import donations from '@itc-mod/donations/web';
import ops from '@itc-mod/ops/web';
import library from '@itc-mod/library/web';
import blueprints from '@itc-mod/blueprints/web';
import shipyards from '@itc-mod/shipyards/web';
import members from '@itc-mod/members/web';
import recruiting from '@itc-mod/recruiting/web';
import ping from '@itc-mod/ping/web';
// new-module: imports (pnpm new-module adds lines above this one)

// The web modules compiled into this build, in nav order. Fleet is first so the rail is Home, then Fleet.
export const modules: readonly WebModule[] = [
  fleet,
  timers,
  bank,
  supply,
  donations,
  ops,
  library,
  blueprints,
  shipyards,
  members,
  recruiting,
  ping,
  // new-module: modules (pnpm new-module adds lines above this one)
];

export const moduleNav: readonly NavItem[] = modules.flatMap((module) => module.nav);
